// Produces rows in the exact shape Be_Auth_DevOps/models/moduleDataList.go's
// FilterCondition already parses (field/op/value/operator), the same
// mechanism DynamicFieldFilter.jsx's Filters drawer uses — reused here rather
// than inventing a second convention for date-range filtering.
//
// Only daterangePreset fields participate today; the shape is generic
// (op: gte/lte/...) so a future field type can emit rows the same way without
// this function changing.
export function buildFilterConditions(values = {}, fields = []) {
  const conditions = [];

  fields.forEach((field) => {
    if (field.type !== 'daterangePreset') return;

    const raw = values[field.field];
    const from = raw?.from;
    const to = raw?.to;
    if (!from && !to) return;

    const targetField = field.filterField || field.field;
    if (from) conditions.push({ field: targetField, op: 'gte', value: from, operator: 'and' });
    if (to) conditions.push({ field: targetField, op: 'lte', value: to, operator: 'and' });
  });

  return conditions;
}
